import { restApi } from "../../services/api";
import { createBasicRepository as createRepository } from "elentari";

const recoveryAccessRepository = createRepository({
  path: "recovery-access",
  restApi,
});

export default recoveryAccessRepository;
